import React, { Component } from "react";

import {
  Wrapper,
  Row,
  Card,
  Copy,
  Bold,
  Button,
  Icon
} from "app/NativeComponents/common";
import PhoneNumberMore from "./PhoneNumberMore";
import {
  callPhoneNumber,
  textPhoneNumber,
  toTitleCase
} from "app/NativeActions";

class PhoneNumberItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show_options: false
    };
    this.toggleOptions = this.toggleOptions.bind(this);
  }

  toggleOptions(show_options = false) {
    this.setState({
      show_options
    });
  }

  renderSource(phone_number) {
    const { colors } = this.props;

    let source = "";
    if (phone_number.manual == 1) {
      source = "Source: Manually Added";
    } else {
      source = "Source: Skip Trace";
    }

    return (
      <Copy style={{ fontSize: 12, color: colors.light_text_color }}>
        {source}
      </Copy>
    );
  }

  renderLabel(phone_number) {
    const { colors } = this.props;
    let label_text = "";
    let label_color = colors.background_color;
    let label_tooltip = "";
    if (phone_number.blocked == 1) {
      label_color = colors.error_color_muted;
      label_text = "Blocked";
    } else if (phone_number.is_litigator == 1) {
      label_color = colors.error_color_muted;
      label_text = "Known Litigator";
    } else if (phone_number.do_not_call == 1) {
      label_color = colors.error_color_muted;
      label_text = "Do Not Call";
    } else if (phone_number.landline == 1) {
      label_color = colors.background_color;
      label_text = "Landline";
    } else if (phone_number.bad_phone == 1) {
      label_color = colors.error_color_muted;
      label_text = "Wrong Number";
    } else if (phone_number.expected_undeliverable) {
      label_color = this.props.colors.error_color_muted;
      label_text = "Undeliverable w/ Message Engine";
      label_tooltip =
        "The carrier for this number prevents sending from this platform.";
    } else if (
      phone_number.manual != 1 &&
      phone_number.checked_landline == 1 &&
      phone_number.did_litigator_scrub == 1
    ) {
      label_color = colors.success_color_muted;
      label_text = "Mobile";
    }
    if (!!label_text) {
      return (
        <Wrapper
          tooltip={label_tooltip}
          style={{
            marginTop: 5,
            backgroundColor: label_color,
            borderRadius: 15,
            padding: 10,
            paddingTop: 5,
            paddingBottom: 5,
            marginRight: 5
          }}
        >
          <Copy style={{ fontSize: 12 }}>{label_text}</Copy>
        </Wrapper>
      );
    }
  }

  renderOptionsButton(phone_number) {
    return (
      <Wrapper
        style={{
          padding: 15,
          paddingLeft: 0,
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Button
          tooltip={"More Options"}
          onPress={() => {
            this.toggleOptions(true);
          }}
          style={{
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Icon icon={"more-vert"} />
        </Button>
      </Wrapper>
    );
  }

  renderMessageButton(phone_number) {
    if (
      phone_number.blocked != 1 &&
      phone_number.is_litigator != 1 &&
      phone_number.do_not_call != 1 &&
      phone_number.landline != 1 &&
      phone_number.bad_phone != 1 &&
      (phone_number.expected_undeliverable != 1 ||
        this.props.device == "mobile")
    ) {
      return (
        <Wrapper
          style={{
            padding: 15,
            paddingLeft: 0,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            tooltip={"Send Message"}
            onPress={() => {
              if (
                this.props.device == "mobile" &&
                ((this.props.plan_module_info &&
                  !this.props.plan_module_info.has_module) ||
                  phone_number.expected_undeliverable == 1)
              ) {
                textPhoneNumber(phone_number.phone_number);
              } else {
                this.props.setToPhoneNumber(phone_number);
                this.props.openActivityTab({
                  activity_tab: "messages",
                  is_activity_open: true
                });
              }
            }}
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Icon icon={"chat"} />
          </Button>
        </Wrapper>
      );
    }
  }

  renderPhoneButton(phone_number) {
    if (
      this.props.device == "mobile" &&
      phone_number.is_litigator != 1 &&
      phone_number.do_not_call != 1 &&
      phone_number.bad_phone != 1
    ) {
      return (
        <Wrapper
          style={{
            padding: 15,
            paddingLeft: 0,
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            tooltip={"Call Phone Number"}
            onPress={() => {
              callPhoneNumber(phone_number.phone_number);
            }}
            style={{
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <Icon icon={"call"} />
          </Button>
        </Wrapper>
      );
    }
  }

  renderCallerId(phone_number) {
    const { colors } = this.props;
    if (!!phone_number.cnam) {
      return (
        <Wrapper
          style={{
            marginTop: 5,
            backgroundColor: colors.background_color,
            borderRadius: 15,
            padding: 10,
            paddingTop: 5,
            paddingBottom: 5,
            marginRight: 5
          }}
        >
          <Copy style={{ fontSize: 12 }}>
            Caller Id: {toTitleCase(phone_number.cnam)}
          </Copy>
        </Wrapper>
      );
    }
  }

  renderCarrier(phone_number) {
    const { colors } = this.props;

    if (!!phone_number.carrier) {
      return (
        <Wrapper
          style={{
            marginTop: 5,
            backgroundColor: colors.background_color,
            borderRadius: 15,
            padding: 10,
            paddingTop: 5,
            paddingBottom: 5,
            marginRight: 5
          }}
        >
          <Copy style={{ fontSize: 12 }}>
            Carrier: {toTitleCase(phone_number.carrier)}
          </Copy>
        </Wrapper>
      );
    }
  }

  renderConnectedDisconnected(phone_number) {
    const { colors } = this.props;
    if (phone_number.connected) {
      if (phone_number.connected == 1) {
        return (
          <Wrapper
            style={{ marginLeft: 10 }}
            tooltip={"This number is connected"}
          >
            <Row>
              <Icon
                icon="check-circle"
                size={14}
                color={colors.success_color}
              />
              <Copy
                style={{
                  textColor: colors.light_text_color,
                  fontSize: 12,
                  marginLeft: 2,
                  marginRight: 5
                }}
              >
                Connected
              </Copy>
            </Row>
          </Wrapper>
        );
      } else if (phone_number.connected == 0) {
        return (
          <Wrapper
            style={{ marginLeft: 10 }}
            tooltip={"This number is disconnected"}
          >
            <Row>
              <Icon icon="cancel" size={14} color={colors.error_color} />
              <Copy
                style={{
                  textColor: colors.light_text_color,
                  fontSize: 12,
                  marginLeft: 2,
                  marginRight: 5
                }}
              >
                Disconnected
              </Copy>
            </Row>
          </Wrapper>
        );
      }
    }
  }

  render() {
    const { phone_number } = this.props;
    return (
      <Card style={{ marginBottom: 0 }}>
        <Wrapper>
          <Row>
            <Wrapper style={{ padding: 15, flex: 1 }}>
              <Row>
                <Copy>
                  <Bold>{phone_number.phone_number}</Bold>
                </Copy>
                {this.renderConnectedDisconnected(phone_number)}
              </Row>

              {!!phone_number.phone_label &&
              phone_number.phone_label !== "Mobile" &&
              phone_number.phone_label !== "Landline" ? (
                <Copy>{phone_number.phone_label}</Copy>
              ) : null}
              {this.renderSource(phone_number)}

              <Row style={{ flexWrap: "wrap" }}>
                {this.renderLabel(phone_number)}
                {this.renderCallerId(phone_number)}
                {this.renderCarrier(phone_number)}
              </Row>
            </Wrapper>
            {this.renderMessageButton(phone_number)}
            {this.renderPhoneButton(phone_number)}
            {this.renderOptionsButton(phone_number)}
          </Row>
        </Wrapper>
        <PhoneNumberMore
          {...this.props}
          phone_number={phone_number}
          show_options={this.state.show_options}
          toggleOptions={this.toggleOptions}
        />
      </Card>
    );
  }
}

export default PhoneNumberItem;
